import { Roles } from '@/core/constants/roleConstants';

export const rolesThatMustSelectChannel = [
  'Director',
  'IELDirector',
  'IELExpressSales',
  'IELBriefcase',
  'DirectorNoCommercial',
  'IELCommercialPR',
  'IELCommercialDT',
  'Subdirector',
  'RegionalManager',
  'IELRegManager',
  'Superuser',
  'IELMarketing',
  Roles.POST_SALE,
  Roles.PRESIDENCY,
];
